import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Account, ClientData, Profile } from '../user-profile-details/client-data';
import { ApiService } from 'src/app/services/api.service';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { PhoneRequest } from 'src/app/models/requests';
import { MatSelectionListChange } from '@angular/material/list';
import { UrlConstants } from 'src/app/models/urlConstants';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-request-change-phone',
  templateUrl: './request-change-phone.component.html',
  styleUrls: ['./request-change-phone.component.scss']
})
export class RequestChangePhoneComponent implements OnInit {
phoneRequest: PhoneRequest;
  phoneForm!: FormGroup;
  userPortfolio!: Profile;
  isLoading = false;
  currentAccount!: Account;
  constructor(
    public translate: TranslateService,
    private fb: FormBuilder,
    private _apiService: ApiService,
    private router: Router,
    private http: HttpClient,
    
  ) { }
  ngOnInit() {
    this.initForm();
    this.getAccountAndProfile();
  }

  initForm() {
    this.phoneForm = this.fb.group({
      phoneNumber: ['', Validators.required]
    });
  }

  getAccountAndProfile() {
    const accList = JSON.parse(localStorage.getItem('accList')!) as Account[];
    this.currentAccount = accList[0];
    this.getPhoneNumbers(this.currentAccount.relationCode);
  }

  getPhoneNumbers(relationCode: string) {
    this.http
      .get<ClientData>(
        `${UrlConstants.backofficeUrl}/api/Client/GetClientInformation?relationCode=${relationCode}`
      )
      .subscribe(res => {
        this.userPortfolio = res.Profile;
        this.phoneForm.patchValue({
          phoneNumber: this.userPortfolio.Phone
        });
      });
  }

  submit() {
    if (this.phoneForm.valid &&
        this.phoneForm.value.phoneNumber !== this.userPortfolio.Phone) {

      const phoneRequest: PhoneRequest = {
        MainCode: 0,
        RelationCode: this.userPortfolio.RelationCode,
        Contact: this.phoneForm.value.phoneNumber,
        Verified: true
      };

      this.openConfirmationModal(phoneRequest);
    }
  }
    openConfirmationModal(phoneRequest) {
    const titleMessage = this.translate.instant("Confirm-Change_Phone_Request");

    const textConfirmMassage = `${this.translate.instant("Confirm-Change_Phone_Request_question")}`+"</br>"+
    `${this.translate.instant("order-rel-code")} : ${phoneRequest.RelationCode }`+"</br>"+
    `${this.translate.instant("clientName")} : ${this.translate.currentLang == "ar"? this.currentAccount.clientNameAr: this.currentAccount.clientNameEn}` +"</br>"+
    +`${this.userPortfolio?.Phone}` +"</br>"+`${this.translate.instant("to")}`+"</br>"+
    `${phoneRequest.Contact}`;


    Swal.fire({
      title: titleMessage,
      html:
        "<pre>" +
        textConfirmMassage +
        "</pre>" ,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: this.translate.instant("yes"),
      cancelButtonText: this.translate.instant("no"),
      reverseButtons: true,
    }).then((result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          this.ChangePhoneRequest(phoneRequest);
        } else if (!result.isConfirmed) {
          this.isLoading = false;
        }
      });
  }
  ChangePhoneRequest(requestDTO: PhoneRequest) {
    this._apiService.ChangePhoneRequest(requestDTO).subscribe((res) => {
      this.isLoading = false;
      Swal.fire({
        position: "center",
        icon: "success",
        title: this.translate.instant("succes-msg"),
        showConfirmButton: false,
        timer: 4500,
      });
      this.router.navigate(['/requests-analysis/requests-table']);
    }, (err) => {
      this.isLoading = false;
      Swal.fire({
        position: "center",
        icon: "error",
        title: this.translate.instant("error-msg"),
        showConfirmButton: false,
        timer: 4500,
      });
    });
  }
}

